import React from "react";
import './FormLoader.css';

const FormLoader = () => {
  return (
    <div className="form-loader-overlay">
      <div className="form-loader-message"></div>
    </div>
  );
};

export default FormLoader;
